module.exports = __webpack_public_path__ + "static/assets/7a52022826eaf883e66daae3a62e5def.svg";